import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { BoxSeam, FileEarmarkText, ClipboardCheck, Cash } from "react-bootstrap-icons";
import { Link } from "react-router-dom"; // use <a> if not using react-router
import { useNavigate } from 'react-router-dom';
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';

function DashboardPage() {
    useEffect(() => {
        fetchRequest();
    }, []);

    const fetchRequest = async () => {
        try {
            debugger;
            setIsLoading(true);
            const response = await adminInstance.get("dashboard/GetDashboard");
            setQuotationCount(response.data.pendingOrders || 0);
            setReimbursementCount(response.data.pendingReimbursements || 0);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
            setIsLoading(false);
        }
    };

    const navigate = useNavigate();
    const [quotationCount, setQuotationCount] = useState(0);
    const [reimbursementCount, setReimbursementCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [userEmail, setUserEmail] = useState(sessionStorage.getItem('username'));

    const goToCatalog = () => {
        var urlName = "MyExpenseRequestDetail";
        //navigate(`/${urlName}/${reqId}`);
    }

    const goToReimbursement = () => {
        var urlName = "MyExpenseRequestDetail";
        //navigate(`/${urlName}/${reqId}`);
    }

    return (
        <Container className="mt-4">
            <h4 className="mb-4">Good Day {userEmail},</h4>

            {/* Pending Counts */}
            <Row className="mb-4">
                <Col md={6}>
                    <Card className="shadow-sm border-0">
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="mb-0">
                                    <ClipboardCheck className="me-2 text-primary" />
                                    Pending Quotation Requests
                                </Card.Title>
                            </div>
                            <Badge bg="primary" pill className="fs-5 px-3">
                                {quotationCount}
                            </Badge>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="shadow-sm border-0">
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="mb-0">
                                    <Cash className="me-2 text-success" />
                                    Pending Reimbursement Requests
                                </Card.Title>
                            </div>
                            <Badge bg="success" pill className="fs-5 px-3">
                                {reimbursementCount}
                            </Badge>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Quick Links */}
            <Row>
                <Col md={6}>
                    <Card className="shadow-sm border-0 h-100 text-center p-3">
                        <BoxSeam size={32} className="text-info mb-2" />
                        <h6>Product Catalog</h6>
                        <Link to="/catalog">
                            <Button variant="outline-info" size="sm" className="mt-2">
                                Go to Catalog
                            </Button>
                        </Link>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="shadow-sm border-0 h-100 text-center p-3">
                        <FileEarmarkText size={32} className="text-warning mb-2" />
                        <h6>Reimbursement Request</h6>
                        <Link to="/MyExpenseRequest">
                            <Button variant="outline-warning" size="sm" className="mt-2">
                                Go to Reimbursement
                            </Button>
                        </Link>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardPage;
